import type {Schemas} from 'domainTypes/dto';
import type {FullManifestation} from '../types';
import {mapManifestationWithExpressionDto} from './mapManifestationWithExpressionDto';

export const mapManifestationsDto = (
  dto: Schemas.ManifestationsDto,
): FullManifestation[] => {
  return (
    dto.manifestations?.map(m => mapManifestationWithExpressionDto(m)) || []
  );
};
